module.exports = __webpack_public_path__ + "img/coin-two.ea07903c.png";